export enum OrganizationRosterEntrySource {
  AccountMenu = 'account_menu',
  OrgCreation = 'org_creation',
  // Matter Manage Members "Manage organization" uses the same roster location state.
  ManageMembers = 'manage_members',
  // Org-admin visit to /dashboard/account redirects to the roster.
  AccountPage = 'account_page',
  // Resolver fallback only — every current call site passes an explicit source.
  Unknown = 'unknown',
}

export enum OrganizationJoinPath {
  NewSignUp = 'new_signup',
  ExistingAccount = 'existing_account',
}
